import React from "react";

export default function NumberCardSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="bg-white flex items-center justify-between space-y-6 flex-col w-full min-h-[280px] h-[280px] p-6 border-[2px] border-gray-300 rounded-xl">
        <div className="w-full flex items-center justify-evenly">
          <div className="h-6 bg-gray-200 rounded w-32"></div>
          <div className="h-6 bg-gray-200 rounded w-16"></div>
        </div>

        <div className="flex items-center justify-evenly w-full">
          <div className="h-2.5 w-2.5 bg-gray-200 rounded-full"></div>
          <div className="h-8 bg-gray-200 rounded w-32"></div>
          <div className="h-6 w-6 bg-gray-200 rounded-full"></div>
        </div>

        <div className="w-full flex items-center justify-center">
          <div className="h-12 bg-gray-200 rounded w-32"></div>
        </div>
      </div>
    </div>
  );
}